import { useEffect } from "react";
import { usePersonSummaryCtx } from "../context/PersonSummaryContext";
import { useTripsCtx } from "../context/TripDetailsContext";

export function useReloadServiceUsers() {
  const { handleManageServiceUsersData, serviceDataCtx } = useTripsCtx();
  const { isLoadingPersonData } = usePersonSummaryCtx();

  useEffect(() => {
    !isLoadingPersonData &&
      !serviceDataCtx[0].length &&
      handleManageServiceUsersData();
  }, [isLoadingPersonData]);
}
